import React, { useEffect, useContext, useCallback } from "react";
import PersonnelConditionButton from "../molecules/PersonnelConditionButton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import ProjectIdField from "../molecules/ProjectIdField";
import { personnelListContext } from "../../PersonnelListPage";
import CostField from "../molecules/CostField";
import KeywordField from "../molecules/KeywordField";
import DateField from "../molecules/DateField";
import PersonnelIdField from "../molecules/PersonnelIdField";
import CheckBelonging from "../molecules/CheckBelonging";
import EmploymentStatusField from "../molecules/EmploymentStatusField";
import CostFluctuationField from "../molecules/CostFluctuationField";
import NotCostSetField from "../molecules/NotCostSetField";
import BaseApi from "../../../../functions/axios";
import PersonnelListFromRecruitment from "./PersonnelListFromRecruitment";
import { Button } from "@mui/material";

const inputAutofillStyle = {
  "& .MuiInputBase-input": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
  },
};

export default function SearchFromRecruitment() {
  const {
    defaultFormData,
    formdataFromRecruitment,
    setFormdataFromRecruitment,
    setAllCount,
    listFromRecruitment = [],
    setListFromRecruitment,
    isEndList,
    setIsEndList,
    isBottom,
    setRecruitment,
  } = useContext(personnelListContext);

  const handleSubmit = async () => {
    if (!formdataFromRecruitment.project_id) {
      alert("募集を選択してください");
      return;
    }
    setIsEndList(false);
    const resetOffsetFormdata = { ...formdataFromRecruitment, offset: 0 };

    try {
      const response = await BaseApi.get("/matching_personnel_list", { params: resetOffsetFormdata });
      const data = response?.data?.data || {};
      setAllCount(data.allCount || 0);
      setListFromRecruitment(data.personnel_list || []);

      if (data.next === 0) {
        setIsEndList(true);
      } else {
        setFormdataFromRecruitment((prev) => ({
          ...prev,
          offset: data.next,
        }));
      }
    } catch (err) {
      console.error("handleSubmit error:", err);
    }
  };

  useEffect(() => {
    const getMatchingList = async () => {
      try {
        const res = await BaseApi.get("project_title");
        setRecruitment(res?.data?.data?.project_list || []);
      } catch (error) {
        console.error("getMatchingList error:", error);
      }
    };
    getMatchingList();
  }, [setRecruitment]);

  // 無限スクロールの取得処理
  const fetchNextPage = useCallback(async () => {
    try {
      const response = await BaseApi.get("/matching_personnel_list", {
        params: formdataFromRecruitment,
      });
      const data = response?.data?.data || {};
      setListFromRecruitment((prev) => [...prev, ...(data.personnel_list || [])]);

      if (data.next === 0) {
        setIsEndList(true);
      } else {
        setFormdataFromRecruitment((prev) => ({
          ...prev,
          offset: data.next,
        }));
      }
    } catch (err) {
      console.error("fetchNextPage error:", err);
    }
  }, [formdataFromRecruitment, setFormdataFromRecruitment, setIsEndList, setListFromRecruitment]);

  useEffect(() => {
    if (isBottom && !isEndList && listFromRecruitment.length > 0) {
      fetchNextPage();
    }
  }, [isBottom, isEndList, listFromRecruitment.length, fetchNextPage]);

  const handleChangeFormData = (newData) => {
    setFormdataFromRecruitment((preData) => ({ ...preData, ...newData }));
  };

  const handleReset = () => {
    setIsEndList(true);
    setFormdataFromRecruitment(defaultFormData);
  };

  return (
    <Box>
      <Grid container alignItems="center">
        <ProjectIdField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.project_id}
        />
        <PersonnelIdField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.personnel_id}
          classes={inputAutofillStyle}
        />
        <KeywordField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.keyword}
          classes={inputAutofillStyle}
        />
        <CostField
          onChange={handleChangeFormData}
          costMaxValue={formdataFromRecruitment.cost_max}
          costMinValue={formdataFromRecruitment.cost_min}
          classes={inputAutofillStyle}
        />
        <DateField
          onChange={handleChangeFormData}
          dateFromValue={formdataFromRecruitment.date_from}
          dateToValue={formdataFromRecruitment.date_to}
          classes={inputAutofillStyle}
        />
        <CheckBelonging
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.belonging}
        />
        <EmploymentStatusField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.employment}
        />
        <CostFluctuationField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.fluctuation}
          disabled={!formdataFromRecruitment.cost_max}
        />
        <NotCostSetField
          onChange={handleChangeFormData}
          value={formdataFromRecruitment.cost_not_set}
          disabled={
            !(
              Boolean(formdataFromRecruitment.cost_min) &&
              Boolean(formdataFromRecruitment.cost_max)
            )
          }
        />
      </Grid>

      <Grid container>
        <Grid item xs={3} />
        <Grid item xs={6}>
          <PersonnelConditionButton onClick={handleSubmit} />
        </Grid>
        <Grid item xs={3}>
          <Button
            color="inherit"
            onClick={handleReset}
            sx={{ mt: { xs: "30px", sm: "40px" } }}
          >
            検索条件をリセット
          </Button>
        </Grid>
      </Grid>

      <PersonnelListFromRecruitment />
    </Box>
  );
}